export class BankingAccountType {
  public id?: string;
  public name: string;
}
